module.exports = __webpack_public_path__ + "static/media/atlanta.fff4e1c1.png";